import styled from "styled-components";

export const CardContainer = styled.div`
  background: #ffffff;
  border: 1px solid #e4e7ec;
  border-radius: 12px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  width: 100%;
  box-sizing: border-box;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
  transition: all 0.2s ease;
  position: relative;
`;

export const ImageSection = styled.div`
  width: 100%;
  /* height: ${({ hasImage }) => (hasImage ? "200px" : "120px")}; */
  height: 200px;
  background: ${({ hasImage }) =>
    hasImage
      ? "transparent"
      : "linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%)"};
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  @media (max-width: 576px) {
    height: ${({ hasImage }) => (hasImage ? "160px" : "100px")};
  }
`;

export const ContentSection = styled.div`
  padding: 20px;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(8px);
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex: 1;

  @media (max-width: 576px) {
    padding: 16px;
    gap: 12px;
  }
`;

export const TagRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;

  @media (max-width: 576px) {
    gap: 6px;
  }
`;

export const ValueBadge = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: 6px;
  background: #ffffff;
  border: 1px solid #d0d5dd;
  font-family: "Geist", sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 20px;
  color: #101828;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);

  @media (max-width: 576px) {
    font-size: 12px;
    padding: 3px 6px;
  }
`;

export const InvestorsBadge = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: 6px;
  background: #ffffff;
  border: 1px solid #d0d5dd;
  font-family: "Geist", sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  color: #414651;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);

  svg {
    width: 12px;
    height: 12px;
    flex-shrink: 0;
  }

  @media (max-width: 576px) {
    font-size: 11px;
    padding: 3px 6px;

    svg {
      width: 10px;
      height: 10px;
    }
  }
`;

export const Description = styled.p`
  font-family: "Geist", sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #667085;
  margin: 0;

  @media (max-width: 576px) {
    font-size: 12px;
    line-height: 18px;
  }
`;

export const StatsRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;

  @media (max-width: 576px) {
    gap: 8px;
  }
`;

export const ShareButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  gap: 8px;
  padding: 10px 16px;

  border: 1px solid #e9eaeb;
  background: #ffffff;
  color: #414651;
  border-radius: 8px;
  cursor: pointer;

  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.05);

  font-family: "Geist", sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;

  transition: background 0.2s ease;

  &:hover {
    background: #f9fafb;
    border-color: #d0d5dd;
  }

  svg {
    stroke: #414651;
    width: 16px;
    height: 16px;
  }

  @media (max-width: 576px) {
    margin-top: 12px;
    width: 100%;
  }
`;

export const StatItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  flex: 1;
  min-width: 0;
  cursor: ${({ $clickable }) => ($clickable ? "pointer" : "default")};

  @media (max-width: 576px) {
    min-width: calc(50% - 4px);
    margin-bottom: 8px;
  }
`;

export const StatLabel = styled.span`
  font-family: "Geist", sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
  color: #717680;
  text-transform: capitalize;
  letter-spacing: 0.5px;

  @media (max-width: 576px) {
    font-size: 9px;
    line-height: 12px;
  }
`;

export const StatValue = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  font-family: "Geist", sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  color: #181d27;

  ${({ positive, negative }) => {
    if (positive) {
      return `color: #10b981;`;
    }
    if (negative) {
      return `color: #ef4444;`;
    }
    return "";
  }}

  svg {
    flex-shrink: 0;
    stroke: #535862;
  }

  @media (max-width: 576px) {
    font-size: 11px;
    line-height: 14px;

    svg {
      width: 10px;
      height: 10px;
    }
  }
`;

export const HoldingsStack = styled.div`
  display: flex;
  align-items: center;
`;

export const HoldingLogo = styled.img`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 1px solid rgba(0, 0, 0, 0.08);
  object-fit: cover;
  margin-left: -6px;
  overflow: hidden;
  z-index: ${({ $index }) => 4 - $index};

  &:first-child {
    margin-left: 0;
  }
`;

export const RiskIndicator = styled.div`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  flex-shrink: 0;

  ${({ level }) => {
    switch (level) {
      case "low":
        return "background: #10b981;";
      case "medium":
        return "background: #f59e0b;";
      case "high":
        return "background: #ef4444;";
      default:
        return "background: #6b7280;";
    }
  }}
`;
